import { render, staticRenderFns } from "./MovementClient.vue?vue&type=template&id=3b6633c0"
import script from "./MovementClient.vue?vue&type=script&lang=js"
export * from "./MovementClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports